// @ts-nocheck
import DataTableHeader, { DataTableHeaderProps } from "@insite/mobius/DataTable/DataTableHeader";
import { DataTableHead } from "@insite/mobius/index";
import getColor from "@insite/mobius/utilities/getColor";
import React from "react";
import { css } from "styled-components";

interface BuyingListManagementTableHeadProps {
    buyingListHeaders: (string | JSX.Element)[];
    headerProps?: DataTableHeaderProps;
}

const BuyingListTableHead: React.FC<BuyingListManagementTableHeadProps> = ({ buyingListHeaders, headerProps }) => {
    return (
        <DataTableHead
            css={css`
                background-color: ${getColor("common.checkboxPickerBackground")};
            `}
        >
            {buyingListHeaders.map(header => (
                <DataTableHeader
                    css={css`
                        background-color: ${getColor("common.checkboxPickerBackground")};
                    `}
                    key={header.toString()}
                    {...headerProps}
                >
                    {header}
                </DataTableHeader>
            ))}
        </DataTableHead>
    );
};
export default BuyingListTableHead;
